var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-button',{class:`btn ${_vm.extraStyle}`,attrs:{"variant":_vm.variantName},on:{"click":() => _vm.$router.go(-1)}},[_vm._v(" <- Back ")])
}
var staticRenderFns = []

export { render, staticRenderFns }